import http from '../utils/request'

// 请求首页数据
export const getData=()=>{
    //返回promise对象
    return http.get('/home/getData')
}

export const getUser = (params) => {
    console.log(params, 'params')
    // 返回用户列表
    return http.get('/user/getUser', params)
}

export const addUser = (data) => {
    return http.post('/user/add', data)
}

export const editUser = (data) => {
    return http.post('/user/edit', data)
}

export const delUser = (data) => {
    return http.post('/user/del', data)
}

export const getMenu = (data) => {
    return http.post('/permission/getMenu', data)
}
export const getGoods = (params) => {
    return http.get('http://localhost:8082/permission/getGoods', params)
}
export const addGood = (data) => {
    return http.post('http://localhost:8082/permission/addGood', data)
}
export const delGood = (params) => {
    return http.get('http://localhost:8082/permission/delGood', params)
}